export default __webpack_public_path__ + "static/media/security.4e578047.png";